import React from 'react'
import { BButton, BCol, BForm, BIcon, BRow } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { ACKNOWLEDGMENT_OF_RECEIPT, IDENTITY_CARD, OTHER_IDENTITY_DOCUMENT } from '../../constants'
import { clientActions, modalDialogActions } from '../../redux'
import { DocsInfo, PageControlButtons } from '../../components'
import { getOpenApiInstance, Response } from '../../api/api'
import bankBranch from '../../assets/bankBranch.svg'
import messages from '../../i18n'
import styles from './styles.scss'

interface Props {
  finishBranch: typeof clientActions.finishBranch
  hideModalDialog: any
  modalId: string
  showModalDialog: any
}

interface State {
  idCard: boolean
  income: boolean
  loaded: boolean
  otherId: boolean
}

export class BranchDocsInfo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      idCard: false,
      income: false,
      loaded: false,
      otherId: false,
    }
  }

  componentDidMount() {
    this.initInfo()
  }

  initInfo = () => {
    // todo: move it to the sagas
    getOpenApiInstance()
      .getNeededDocs({})
      .then((response: any) => {
        if (response.responseStatus === Response.ok) {
          const docList = response.data?.documentTypes
          this.setState({
            idCard: docList.includes(IDENTITY_CARD),
            income: docList.includes(ACKNOWLEDGMENT_OF_RECEIPT),
            loaded: true,
            otherId: docList.includes(OTHER_IDENTITY_DOCUMENT),
          })
        } else {
          this.setState({
            idCard: true,
            income: true,
            loaded: true,
            otherId: true,
          })
        }
      })
  }

  goToBranch = () => this.props.finishBranch(this.goToBranch)

  close = () => {
    this.props.hideModalDialog(this.props.modalId)
  }

  render() {
    const { loaded, idCard, otherId, income } = this.state

    return (
      loaded && (
        <BForm component="div">
          <BButton
            testid="closeButton"
            theme={styles.closeButton}
            color="link"
            onClick={this.close}>
            <BIcon name="delete" />
          </BButton>
          <BRow>
            <BCol theme="mb-3 d-flex justify-content-center">
              <img src={bankBranch} alt="" />
            </BCol>
          </BRow>

          <DocsInfo idCard={idCard} income={income} otherId={otherId} />

          <PageControlButtons
            onSubmit={this.goToBranch}
            submitMessage={messages.docsInfo.goToBranches}
          />
        </BForm>
      )
    )
  }
}

export default compose(
  connect(null, {
    finishBranch: clientActions.finishBranch,
    hideModalDialog: modalDialogActions.hideModalDialog,
    showModalDialog: modalDialogActions.showModalDialog,
  })
)(BranchDocsInfo)
